import React from 'react';
import { Box, Typography, Grid, Stack } from '@mui/material';
import { InfoRow } from './InfoRow';
import { IDataprevEmployee } from 'services/zetra';

export interface EmployeeCardField {
    label: string;
    value: string | number | React.ReactNode;
}

interface EmployeeCardProps {
    fields: EmployeeCardField[];
    headerData?: IDataprevEmployee;
}

export const EmployeeCard: React.FC<EmployeeCardProps> = ({ fields }) => {
    return (
        <Stack
            sx={{
                width: '100%',
                p: 5,
                borderRadius: 2,
                backgroundColor: '#F4F3F3',
                mb: 2
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    mb: 2
                }}
            >
                <Box>
                    <Typography
                        variant="body2"
                        sx={{
                            fontFamily: 'Lato',
                            fontWeight: 400,
                            fontSize: '17px',
                            lineHeight: '120%',
                            letterSpacing: '-0.2px'
                        }}
                    >
                        Dados pessoais
                    </Typography>
                </Box>
            </Box>
            <Grid container spacing={0} alignItems="stretch">
                {fields.map((field, idx) => (
                    <Grid item xs={12} sm={6} md={2.4} key={idx}>
                        <InfoRow label={field.label} value={field.value} />
                    </Grid>
                ))}
            </Grid>
        </Stack>
    );
};
